module.exports = __webpack_public_path__ + "static/img/img5.e6168945.png";